export const setsUnion = (setA: Set<any>, setB: Set<any>) => {
    return new Set([...setA, ...setB]);
};
